import { SxProps, Theme } from '@mui/material';

export const DpLinkTerminos: SxProps<Theme> = {
	fontSize: 'var(--font-size-caption)',
	color: '#929292',
	'&:hover': {
		color: 'gray',
	},
};
